var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-combobox',{ref:"select",attrs:{"label":_vm.label,"items":_vm.items,"clearable":""},on:{"click:clear":function($event){return _vm.clear()}},model:{value:(_vm.select),callback:function ($$v) {_vm.select=$$v},expression:"select"}})}
var staticRenderFns = []

export { render, staticRenderFns }